module.exports = __webpack_public_path__ + "img/roulette-cube.ff96538b.svg";